<template>
  <v-card class="pa-4">
    <p>{{ text }}</p>
    <v-layout row wrap justify-space-between>
      <v-btn flat @click="$emit('close')" class="mx-0">{{$lang.actions.no}}</v-btn>
      <v-btn color="primary" @click="$emit('submit')" class="mx-0">{{$lang.actions.yes}}</v-btn>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    props: ['text'],
  }
</script>


// WEBPACK FOOTER //
// ConfirmationModal.vue?367d4cc4